import { Controller } from '@hotwired/stimulus'
import { put } from '@rails/request.js'

export default class extends Controller {
  dismiss() {
    this.element.classList.add('hidden')
    put('/phone_number_nudge_dismissal')
  }
}
